<app-detail-template>
  <div container-header>
    <retrieval-emr-detail-header></retrieval-emr-detail-header>
  </div>
  <div container-body>
    <router-outlet></router-outlet>
  </div>
</app-detail-template>
